module.exports = __webpack_public_path__ + "img/icon-10.dbbb1b1c.png";